import { remove } from '@core/api/baseApi';

const deleteStudy = async (studyInstanceUid: string): Promise<{ success: boolean }> =>
  await remove(`/studies/${studyInstanceUid}`);

export default deleteStudy;
